import React, {useCallback, useRef} from 'react'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {Menu, MenuItemData} from '@components/common/base/menu'
import {Dropdown, TippyInstance} from '@components/common/dropdown/dropdown'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {MenuIconButton} from './menu-icon-button'

export interface Props {
  options: OptionsItem[]
  onClick: () => void
  icon: TablerIcons
  notification?: boolean
  className?: string
  active?: boolean
}

export const MenuIconButtonWithDropdown = (props: Props) => {
  const {icon, onClick, notification, className, active, options} = props

  const items = options.map(x => {
    const res: MenuItemData = {
      id: x.key,
      icon: x.icon,
      iconColor: 'icon-secondary',
      title: x.text,
      onClick: x.cb
    }
    if (x.count) {
      const className = cn(
        'text-14',
        'leading-4',
        x.highlightNumber
          ? 'text-notification-primary'
          : 'text-panel-text-secondary'
      )
      res.after = <span className={className}>{x.count}</span>
    }
    return res
  })

  const ref = useRef<HTMLDivElement>(null)
  const instanceRef = useRef<TippyInstance>()

  const hide = useCallback(() => instanceRef.current?.hide(), [instanceRef])

  return (
    <>
      <MenuIconButton
        ref={ref}
        className={className}
        icon={icon}
        onClick={onClick}
        notification={notification}
        active={active}
      />
      <Dropdown
        reference={ref}
        instanceRef={instanceRef}
        hideArrow
        hideOverlay
        maxWidth={224}
        trigger="mouseenter"
        placement="right-start"
        theme="new-menu"
        fallbackPlacements={['right-end', 'right']}
        content={
          <Menu
            className="fix-perfect-scrollbar"
            items={items}
            onItemClicked={hide}
          />
        }
        offset={({placement}) => {
          if (placement === 'right-start') {
            return [-8, 4]
          } else if (placement === 'right-end') {
            return [8, 4]
          } else {
            return [0, 4]
          }
        }}
      />
    </>
  )
}
